import { ArrowRight } from 'lucide-react';

export default function ToolHero({ tool }) {
  return (
    <section className="relative min-h-[88vh] flex items-center justify-center overflow-hidden bg-hero-gradient pt-20 pb-16">
      {/* Gradient blobs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-32 -left-32 w-[480px] h-[480px] rounded-full bg-brand-blue opacity-20 blur-3xl animate-float" />
        <div className="absolute -bottom-32 -right-32 w-[480px] h-[480px] rounded-full bg-brand-indigo opacity-25 blur-3xl animate-float-slow" />
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[320px] h-[320px] rounded-full bg-blue-500 opacity-10 blur-3xl animate-float" />
      </div>

      {/* Grid overlay */}
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage:
            'linear-gradient(rgba(255,255,255,0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.3) 1px, transparent 1px)',
          backgroundSize: '60px 60px',
        }}
      />

      <div className="relative z-10 max-w-4xl mx-auto px-5 sm:px-8 text-center">
        {/* Badge */}
        <div className="flex justify-center mb-6 animate-fade-in">
          <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full glass text-white/80 text-xs font-semibold tracking-wider uppercase">
            {tool.badge}
          </span>
        </div>

        {/* H1 */}
        <h1 className="text-5xl sm:text-6xl md:text-7xl font-extrabold text-white leading-[1.08] tracking-tight mb-6 animate-fade-in-up">
          <span className="text-gradient-light">{tool.h1}</span>
        </h1>

        {/* Description */}
        <p
          className="text-lg sm:text-xl text-white/65 max-w-2xl mx-auto leading-relaxed mb-10 animate-fade-in-up"
          style={{ animationDelay: '0.1s', opacity: 0 }}
        >
          {tool.description}
        </p>

        {/* CTA buttons */}
        <div
          className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up"
          style={{ animationDelay: '0.2s', opacity: 0 }}
        >
          <a
            href={tool.appUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2.5 px-8 py-4 rounded-full bg-white text-brand-blue font-bold text-base shadow-2xl shadow-black/30 hover:shadow-white/20 hover:scale-105 transition-all duration-250"
          >
            {tool.primaryCta}
            <ArrowRight
              size={18}
              className="transition-transform duration-200 group-hover:translate-x-1"
              aria-hidden="true"
            />
          </a>
          <a
            href="#how-it-works"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full glass text-white font-semibold text-base hover:bg-white/15 transition-all duration-200"
          >
            See How It Works
          </a>
        </div>

        {/* Trust message */}
        <p
          className="mt-8 text-sm text-white/35 animate-fade-in"
          style={{ animationDelay: '0.4s', opacity: 0 }}
        >
          {tool.trustMessage}
        </p>
      </div>
    </section>
  );
}
